var mousedownHappened = false
var improvedError = improvedError || false
var validatePhone = validatePhone || true
;(function() {
  // Define option defaults
  defaults = {
    content: '',
  }
  this.frmValidate = function(config) {
    defaults = config || defaults

    var form = defaults.form || document.querySelector(defaults.content)
    var inputs = form ? form.querySelectorAll('input') : []

    for (var i = 0; i < inputs.length; i++) {
      //adding blur and invalid events for required and datarequiredfield. Data Required Field is for phone number
      if (inputs[i].required || inputs[i].hasAttribute('datarequiredfield')) {
        inputs[i].addEventListener('blur', validate)
        inputs[i].addEventListener('invalid', validate)
      }
      //add trimSpaces to all the input to remove spaces
      inputs[i].addEventListener('focusout', trimSpaces)
      if (improvedError) {
        inputs[i].addEventListener('focusin', function() {
          this.classList.remove('invalid')
          if (
            $(this.parentNode).length == 0 ||
            $(this.parentNode).hasClass('field_with_errors')
          ) {
            $(this)
              .parent()
              .parent()
              .find('span.error_field')
              .remove()
          }
          $(this.parentNode)
            .find('span.error_field')
            .remove()
          $(this)
            .parent()
            .next('i.error_icon')
            .remove()
          $(this)
            .next('i.error_icon')
            .remove()
        })
      }
      inputs[i].setCustomValidity('')
    }
    // Turn off the bubbles
    if (form) {
      form.addEventListener(
        'invalid',
        function(event) {
          if ($(event.target).is(':visible')) {
            event.preventDefault()
            this.noValidate = false
          } else {
            this.noValidate = true
          }
        },
        true
      )
    }

    $('.form_validate').on('submit', function(event) {
      if (!this.checkValidity()) {
        var isValidVisibleFields = true
        $(this)
          .find('input:visible')
          .each(function() {
            isValidVisibleFields = isValidVisibleFields && this.validity.valid
          })
        if (isValidVisibleFields) {
          this.noValidate = true
          executeRecaptcha()
          submitUserform(this)
        } else {
          this.noValidate = false
          event.preventDefault()
        }
      } else if ($(this).has('input.invalid').length != 0) {
        event.preventDefault()
        return false
      } else {
        executeRecaptcha()
        submitUserform(this)
      }
    })
  }

  var whichError = function(obj) {
    if (obj.valueMissing) {
      return 'data-required-message'
    } else if (obj.tooShort) {
      return 'data-tooshort-message'
    } else if (obj.typeMismatch || obj.patternMismatch) {
      return 'data-type-message'
    }
  }
  function submitUserform(obj) {
    if (!$(obj).data('remote')) {
      if ($('#user_phone').length > 0) {
        $('#user_phone').val(
          $('#user_phone')
            .val()
            .replace(/\(|\)|-|_| /g, '')
        )
      }
      var wait_message =
        $(obj).attr('data-wait-message') || 'Please wait while we sign you up'
      GC.loader.show_wait_screen({ message: wait_message })
    }
  }
  /*to remove spaces from the start and the end of the input value except for password field*/
  function trimSpaces() {
    if (this.type != 'password' && this.type != 'file') {
      this.value = this.value.trim()
    }
  }
  function validate() {
    /*to remove spaces from the start and the end of the input value except for password field*/
    if (
      $('label[for=' + this.id + ']')
        .parent()
        .is(':visible')
    ) {
      var parent = $('label[for=' + this.id + ']').parent()

      // TODO: modify it with next validation user story
      //Rails 4 is adding field_with_errors container div to label and input with error
      //we can change the way to find parent, probably a error_container class on main box should work
      if (parent.hasClass('field_with_errors')) {
        parent = parent.parent()
      }
      var errorNode = parent.find('span').hasClass('error_field')
      var successNode = parent.find('span').hasClass('success_field')
      var span = document.createElement('span')

      // if tries to add too many blank spaces only then it should be treated as blank value
      if (!containsAtLeastCharacter($(this).val())) {
        $(this).val('')
      }

      if (mousedownHappened) {
        // cancel the blur event
        mousedownHappened = false
      } else {
        // blur event is okay

        this.classList.remove('invalid')
        this.classList.add('valid')

        errorNode
          ? $(parent)
              .find('.error_field')
              .remove()
          : ''
        successNode
          ? $(parent)
              .find('.success_field')
              .remove()
          : ''

        $(this.parentNode)
          .find('span.error_field')
          .remove()
        this.parentNode.appendChild(span)

        var customClass = 'fa-check text-success'
        if (!this.validity.valid) {
          this.classList.add('invalid')
          customClass = 'fa-exclamation text-danger'
          span.classList.add('error_field')
          span.innerHTML = this.getAttribute(whichError(this.validity))
        } else {
          this.setCustomValidity('')
          if (this.name.indexOf('password_confirmation') != -1) {
            if (
              $('input[name=password]').val() === $(this).val() ||
              $('input[name="user[password]"]').val() === $(this).val()
            ) {
              errorNode
                ? $(parent)
                    .find('.error_field')
                    .remove()
                : ''
              successNode
                ? $(parent)
                    .find('.success_field')
                    .remove()
                : ''
              $(this.parentNode)
                .find('span.error_field')
                .remove()
              this.parentNode.appendChild(span)
              this.classList.remove('invalid')
              customClass = 'fa-check text-success'
              span.classList.contains('success_field')
                ? ''
                : span.classList.add('success_field')
            } else {
              this.classList.add('invalid')
              this.validity['valid'] = false
              customClass = 'fa-exclamation text-danger'
              span.classList.add('error_field')
              span.innerHTML = 'Passwords must match'
            }
          } else {
            span.classList.contains('success_field')
              ? ''
              : span.classList.add('success_field')
          }
        }
        if (improvedError) {
          var errorIcon = parent.find('i').hasClass('error_icon')
          var phoneField = $(this)
            .attr('id')
            .match('phone')
          if (!errorIcon) {
            $(this).after("<i class='error_icon fa  fa-fw fa-lg'></i>")
          }
          parent.find('i.error_icon').addClass(customClass)
          if (
            phoneField &&
            $('#user_country option:selected').text() !=
              'United States of America' &&
            validatePhone
          ) {
            parent.find('i.error_icon').remove()
          }
        }
      }
    }
  }
})()

window.isNumber = function(evt) {
  evt = evt ? evt : window.event
  var charCode = evt.which ? evt.which : evt.keyCode
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false
  }
  return true
}

var frmvalid = new frmValidate({
  content: '.form_validate',
})

window.formatPhoneNumber = function(elem) {
  if ($('#user_country option:selected').text() == 'United States of America') {
    if ($(elem).val().length > 0) {
      var phone = $(elem)
        .val()
        .replace(/\(|\)|-|_| /g, '')
      $(elem).val(
        '(' +
          phone.substr(0, 3) +
          ') ' +
          phone.substr(3, 3) +
          '-' +
          phone.substr(6, 4)
      )
    }
  }
}

window.containsAtLeastCharacter = function(inputtxt) {
  return inputtxt.trim().length > 0
}

$(document).ready(function() {
  $('input[type="file"]').change(function() {
    if (this.value) {
      $(this)
        .next()
        .remove()
    }
  })
})
function executeRecaptcha() {
  grecaptcha.ready(function() {
    grecaptcha
      .execute('6LfE68wUAAAAANztJaT-WWfH7H42rqIZ7wOQ4YIq')
      .then(function(token) {
        return token
      })
  })
}
